module.exports = __webpack_public_path__ + "img/crack.eccbb135.gif";